import { useRef, type HTMLAttributes } from 'react';

import { responsiveLabelContainer } from './GaugeResponsiveLabel.sty.js';
import { useMergeRefs } from '../../../../core/hooks/useMergeRefs.js';
import { FONT_HEIGHT_RATIO } from '../../../core/components/single-value-renderer/constants.js';
import { useFontSizeForContainer } from '../../../core/components/single-value-renderer/hooks/use-font-size-for-container.js';
import { useObserveContainerSize } from '../../../core/hooks/useObserveContainerSize.js';

interface GaugeResponsiveLabelProps
  extends HTMLAttributes<HTMLParagraphElement> {
  text: string;
}

export const GaugeResponsiveLabel = (props: GaugeResponsiveLabelProps) => {
  const { text, ...paragraphProps } = props;

  const labelRef = useRef<HTMLParagraphElement>(null);

  const [{ width, height }, observerRef] = useObserveContainerSize();

  const ref = useMergeRefs([labelRef, observerRef]);

  const preferredFontSize = useFontSizeForContainer({
    container: { width: width, height: height * FONT_HEIGHT_RATIO },
    text,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    element: labelRef.current!,
  });

  return (
    <p
      ref={ref}
      className={responsiveLabelContainer}
      style={{
        fontSize: preferredFontSize,
      }}
      {...paragraphProps}
    >
      {text}
    </p>
  );
};
